import { render, staticRenderFns } from "./login.vue?vue&type=template&id=f64876d6&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=f64876d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64876d6",
  null
  
)

export default component.exports